/* =====================================================================
   PhantomR — "My Garage". Saves the shopper's vehicle (make/model/cab) to
   localStorage and surfaces matching kits. Header chip ([data-garage-toggle])
   opens the modal (sections/garage-modal.liquid), which carries its own kit
   data blob ([data-garage-data]) emitted by snippets/fitment-json.liquid.
   Guest-friendly (no login). Mirrors the search-modal open/close pattern.
   ===================================================================== */
(function () {
  "use strict";
  var U = (window.PhantomR && window.PhantomR.utils) || {};
  var KEY = "phantomr:garage";

  function esc(s) { var d = document.createElement("div"); d.textContent = s == null ? "" : s; return d.innerHTML; }
  function escAttr(s) { return esc(s).replace(/"/g, "&quot;"); }
  function uniqSorted(a) { return a.filter(function (v, i) { return v && a.indexOf(v) === i; }).sort(); }
  function handle(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, ""); }
  function money(cents) {
    if (typeof cents !== "number") return "";
    return U.formatMoney ? U.formatMoney(cents, window.PhantomR && window.PhantomR.moneyFormat) : "$" + (cents / 100).toFixed(2);
  }

  function read() { try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch (e) { return null; } }
  function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function wipe() { try { localStorage.removeItem(KEY); } catch (e) {} }
  function label(v) { return v ? (v.make + " " + v.model + (v.cab ? " · " + v.cab : "")) : ""; }

  /* ---------------------------------------------------------------- chips */
  function renderChips() {
    var v = read();
    document.querySelectorAll("[data-garage-toggle]").forEach(function (btn) {
      var lab = btn.querySelector("[data-garage-chip-label]");
      btn.classList.toggle("is-set", !!v);
      if (lab) lab.textContent = v ? label(v) : (btn.getAttribute("data-empty-label") || "Add vehicle");
      btn.setAttribute("aria-label", v ? ("Your garage: " + label(v) + ". Tap to change.") : "Add your vehicle to your garage");
    });
  }

  /* --------------------------------------------------------------- modal */
  var modal = document.querySelector("[data-garage-modal]");
  var makeSel, modelSel, cabField, cabSel, form, saveBtn, saveLabel, clearBtn, results, titleEl;
  var byMake = {};
  var release = null;
  var defaultTitle = "Add your vehicle";

  if (modal) {
    makeSel = modal.querySelector("[data-garage-make]");
    modelSel = modal.querySelector("[data-garage-model]");
    cabField = modal.querySelector("[data-garage-cab-field]");
    cabSel = modal.querySelector("[data-garage-cab]");
    form = modal.querySelector("[data-garage-form]");
    saveBtn = modal.querySelector("[data-garage-save]");
    saveLabel = modal.querySelector("[data-garage-save-label]");
    clearBtn = modal.querySelector("[data-garage-clear]");
    results = modal.querySelector("[data-garage-results]");
    titleEl = modal.querySelector("[data-garage-title]");
    if (titleEl && titleEl.textContent.trim()) defaultTitle = titleEl.textContent.trim();

    var dataEl = modal.querySelector("[data-garage-data]");
    var items = [];
    if (dataEl) { try { items = JSON.parse(dataEl.textContent) || []; } catch (e) { items = []; } }
    items.forEach(function (it) { (byMake[it.make] = byMake[it.make] || []).push(it); });
  }

  function fill(sel, values, ph) {
    sel.innerHTML = "";
    var o = document.createElement("option"); o.value = ""; o.textContent = ph; sel.appendChild(o);
    values.forEach(function (v) { var x = document.createElement("option"); x.value = v; x.textContent = v; sel.appendChild(x); });
  }

  function buildMakes() {
    if (!makeSel) return;
    uniqSorted(Object.keys(byMake)).forEach(function (m) {
      var o = document.createElement("option"); o.value = m; o.textContent = m; makeSel.appendChild(o);
    });
  }

  function refreshModels(make, keep) {
    fill(modelSel, uniqSorted((byMake[make] || []).map(function (i) { return i.model; })), "Select model");
    modelSel.disabled = !make;
    if (keep) modelSel.value = keep;
  }

  function refreshCabs(make, model, keep) {
    if (!cabField || !cabSel) return;
    var cabs = uniqSorted((byMake[make] || []).filter(function (i) { return i.model === model; }).map(function (i) { return i.cab; }));
    if (model && cabs.length > 1) {
      fill(cabSel, cabs, "Any cab"); cabSel.disabled = false; cabField.hidden = false;
      if (keep) cabSel.value = keep;
    } else {
      cabField.hidden = true; cabSel.disabled = true;
    }
  }

  function matches(make, model, cab) {
    return (byMake[make] || []).filter(function (i) { return i.model === model && (!cab || i.cab === cab); });
  }

  function syncSave() {
    if (saveBtn) saveBtn.disabled = !(makeSel.value && modelSel.value);
  }

  function renderResults(make, model, cab) {
    if (!results) return;
    if (!make || !model) { results.hidden = true; results.innerHTML = ""; return; }
    var list = matches(make, model, cab);
    var head = '<p class="garage-results__label">' +
      (list.length
        ? (list.length + (list.length === 1 ? " kit" : " kits") + " fit your " + esc(make) + " " + esc(model))
        : ("No exact kit yet for the " + esc(make) + " " + esc(model) + " — browse the full range below.")) +
      "</p>";
    var cards = list.map(function (it) {
      return '<a class="garage-card" href="' + escAttr(it.url) + '">' +
        (it.image ? '<span class="garage-card__media"><img src="' + escAttr(it.image) + '" alt="" loading="lazy" width="56" height="56"></span>' : "") +
        '<span class="garage-card__body">' +
          (it.type ? '<span class="garage-card__type">' + esc(it.type) + "</span>" : "") +
          '<span class="garage-card__title">' + esc(it.title) + "</span>" +
          (money(it.price) ? '<span class="garage-card__price">' + money(it.price) + (it.available ? "" : " · sold out") + "</span>" : "") +
        "</span>" +
        '<span class="garage-card__cta" aria-hidden="true">&rarr;</span></a>';
    }).join("");
    var browse = '<a class="garage-results__browse link-arrow" href="/collections/' + handle(make) + '">Browse all ' + esc(make) + " kits &rarr;</a>";
    results.innerHTML = head + (cards ? '<div class="garage-results__list">' + cards + "</div>" : "") + browse;
    results.hidden = false;
  }

  function populateForm() {
    if (!makeSel) return;
    var v = read();
    if (v && byMake[v.make]) {
      makeSel.value = v.make;
      refreshModels(v.make, v.model);
      refreshCabs(v.make, v.model, v.cab);
      if (titleEl) titleEl.textContent = label(v);
      if (clearBtn) clearBtn.hidden = false;
      if (saveLabel) saveLabel.textContent = "Update vehicle";
      renderResults(v.make, v.model, (cabField && !cabField.hidden) ? v.cab : "");
    } else {
      makeSel.value = "";
      refreshModels("", "");
      if (cabField) cabField.hidden = true;
      if (titleEl) titleEl.textContent = defaultTitle;
      if (clearBtn) clearBtn.hidden = true;
      if (saveLabel) saveLabel.textContent = "Save to garage";
      if (results) { results.hidden = true; results.innerHTML = ""; }
    }
    syncSave();
  }

  function open(opener) {
    if (!modal) return;
    populateForm();
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    if (U.lockScroll) U.lockScroll();
    if (U.showOverlay) U.showOverlay();
    if (U.trapFocus) release = U.trapFocus(modal, opener);
  }

  function close() {
    if (!modal || !modal.classList.contains("is-open")) return;
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    if (U.unlockScroll) U.unlockScroll();
    if (U.hideOverlay) U.hideOverlay();
    if (release) { release(); release = null; }
  }

  /* --------------------------------------------------------------- events */
  if (makeSel) makeSel.addEventListener("change", function () {
    refreshModels(makeSel.value, ""); if (cabField) cabField.hidden = true;
    renderResults(makeSel.value, "", ""); syncSave();
  });
  if (modelSel) modelSel.addEventListener("change", function () {
    refreshCabs(makeSel.value, modelSel.value, "");
    renderResults(makeSel.value, modelSel.value, "");
    syncSave();
  });
  if (cabSel) cabSel.addEventListener("change", function () {
    renderResults(makeSel.value, modelSel.value, cabSel.value);
  });
  if (form) form.addEventListener("submit", function (e) {
    e.preventDefault();
    var make = makeSel.value, model = modelSel.value;
    if (!make || !model) return;
    var cab = (cabField && !cabField.hidden && cabSel) ? cabSel.value : "";
    write({ make: make, model: model, cab: cab, savedAt: Date.now() });
    renderChips();
    if (clearBtn) clearBtn.hidden = false;
    if (saveLabel) saveLabel.textContent = "Update vehicle";
    if (titleEl) titleEl.textContent = label({ make: make, model: model, cab: cab });
    renderResults(make, model, cab);
  });
  if (clearBtn) clearBtn.addEventListener("click", function () {
    wipe(); renderChips(); populateForm();
  });

  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-garage-toggle]");
    if (toggle) { e.preventDefault(); open(toggle); return; }
    if (e.target.closest("[data-garage-close]")) { e.preventDefault(); close(); }
  });
  document.addEventListener("phantomr:dismiss", close);

  /* ----------------------------------------------------------------- boot */
  buildMakes();
  renderChips();
})();
